import script from "./InfoBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoBlock.vue?vue&type=script&setup=true&lang=ts"

import "./InfoBlock.vue?vue&type=style&index=0&id=ca3160bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca3160bc"]])

export default __exports__